<template>
  <b-modal
    id="materialhistory-modal"
    title="Historia materiału"
    size="lg"
    @show="onShow"
    hide-footer
  >
    <div v-if="loading">
      <TableSpiner />
    </div>
    <div v-else>
      <h2>{{material.name}}</h2>
      <b-table
        class="table table-list table-mobile bills-table"
        ref="bills_table"
        :fields="fields"
        :busy="isBusy"
        :items="historyInfo"
        stacked="lg"
        show-empty
        empty-text="Brak Wpisów"
      >
        <template v-slot:table-busy>
          <TableSpiner />
        </template>
        <template v-slot:empty="{ emptyText }">
          <div class="empty">
            <!-- <i class="fas fa-box-open empty-state"></i> -->
            <i class="fas fa-history empty-state"></i>
            <span class="empty-search">{{ emptyText }}</span>
          </div>
        </template>
        <template v-slot:cell(date)="data">{{ data.item.issue_date | date }}</template>
        <template v-slot:cell(type)="data">
          <label v-if="data.item.type === 'wz'" class="badge badge-primary">Wydanie materiału</label>
          <label v-else-if="data.item.type === 'zw'" class="badge badge-info">Zwrot wydanego materiału</label>
          <label v-else-if="data.item.type === 'pz'" class="badge badge-success">Przyjęcie materiału</label>
          <label v-else-if="data.item.type === 'zpz'" class="badge badge-secondary">Zwrot przyjętego materiału</label>
        </template>
        <template v-slot:cell(construction_name)="data">
          <p v-if="data.item.construction === null" style="margin: 0;">-</p>
          <p v-if="data.item.construction !== null" style="margin: 0;">
            <router-link
              :to="'/construction/'+data.item.construction.id"
            >{{data.item.construction.name}}</router-link>
          </p>
        </template>
        <template v-slot:cell(quantity)="data">{{data.item.quantity}}</template>
        <template v-slot:cell(price)="data">{{data.item.price.toFixed(2)}}</template>
      </b-table>
    </div>
  </b-modal>
</template>
<script>
//TODO: Pamiętać by dodac input z latami, by móc wybierac informacje
import { Materials } from "@/services/warehouse.service";
import TableSpiner from "@/components/TableSpiner";
import {formatDateTime} from "@/services/helpers";

export default {
  name: "ModalMaterialHistory",
  components: { TableSpiner },
  props: {
    material: {
      type: Object
    }
  },

  data() {
    return {
      isBusy: false,
      loading: true,
      historyInfo: {},
      fields: [
        { key: "date", label: "Data zdarzenia", class: "matfoto" },
        { key: "type", label: "Typ", class: "" },
        { key: "construction_name", label: "Budowa", class: "" },
        { key: "quantity", label: "Ilość", class: "text-right" },
        { key: "price", label: "Cena za sztukę", class: "text-right" }
      ]
    };
  },
  filters: {
    date(value) {
      return formatDateTime(value, "YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    onShow() {
      if (this.historyInfo.id && this.material.id === this.historyInfo.id) {
        this.loading = false;
        return;
      }
      this.loading = true;
      Materials.getMaterialLogs(this.material.id)
        .then(data => {
          this.historyInfo = data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
